<template>
  <div
    ref="animationContainer"
    class="w-full"
  />
</template>

<script setup lang="ts">
import lottie from 'lottie-web/build/player/lottie_light'
import animationData from '@/assets/lottie/food-scientists.json'
import { onMounted, ref } from 'vue'

const animationContainer = ref()

onMounted(() => {
  lottie.loadAnimation({
    container: animationContainer.value, // the dom element that will contain the animation
    loop: false,
    autoplay: true,
    animationData // the path to the animation json
  })
})
</script>
